import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { apiPath } from '@/constants/defaultValues';
import { Post, Put } from '@/api/api-middleware';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  employeeCategoryList: [],
  employeeCategory: {},
  loading: false,
  error: '',
};

export const fetchEmployeeCategory = createAsyncThunk(
  'employeeCategory/fetchEmployeeCategory',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEmployeeCategory();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          value: item.id,
          key: item.id,
          code: item.code,
          isDefaultValue: item?.isDefaultValue,
          optionalField1: item?.optionalField1 === 'true'
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const SaveEmployeeCategory = createAsyncThunk(
  'scheduleCategory/SaveEmployeeCategory',
  async (params, thunkAPI) => {
    try {
      return null;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
const employeeCategorySlice = createSlice({
  name: 'employeeCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeCategoryList = action.payload;
        state.error = '';
      })
      .addCase(fetchEmployeeCategory.rejected, (state, action) => {
        state.loading = false;
        state.employeeCategoryList = [];
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(SaveEmployeeCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(SaveEmployeeCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeCategory = action.payload;
        state.error = '';
      })
      .addCase(SaveEmployeeCategory.rejected, (state, action) => {
        state.loading = false;
        state.employeeCategory = {};
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default employeeCategorySlice.reducer;
